// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"b99d7227","673":"4536b035","720":"dd5bc534","787":"d16d0675","830":"99f8f6e9","989":"202bf587"}[chunkId] + ".chunk.js";
};